import Constants from "../common/Constants";
import FindResourceEntryInteractor from "../../core/interactor/app/crud/FindResourceEntryInteractor";
import { ICourtCase } from "../model/CourtCase";
import CourtCaseMapper from "../service/CourtCaseMapper";
import CourtCaseParamMapper from "../service/CourtCaseParamMapper";

export default class FindCourtCaseWithAllDecisionsInteractor {
  private resource: FindResourceEntryInteractor<ICourtCase>;

  constructor({ findResourceEntry }: any) {
    this.resource = findResourceEntry;
  }

  async execute(courtCaseNumber: string) {
    return this.resource.execute(
      `${Constants.courtCasesPath}/details/decisions`,
      CourtCaseMapper,
      CourtCaseParamMapper,
      courtCaseNumber
    );
  }
}
